import React from 'react';
import { number, oneOf, string } from 'prop-types';
import classNames from 'classnames';
import './tray-header.scss';

export const TrayHeader = ({ channel, dimensions, subtotal }) => {
  const isMobile = channel === 'mobile';
  const subtotalTextClasses = classNames('tray-header__subtotal-text', {
    'tray-header__subtotal-text--bold': isMobile
  });

  return (
    <div className="grid tray-header">
      <div className="tray-header__your-samples-text-wrapper">
        <span className="tray-header__your-samples-text">Your Samples&nbsp;</span>
        <span>
          {dimensions}
        </span>
      </div>
      <div className="tray-header__subtotal-wrapper">
        <span className={subtotalTextClasses}>Total:&nbsp;</span>
        <span className="tray-header__subtotal-value">${subtotal.toFixed(2)}</span>
      </div>
    </div>
  );
};

TrayHeader.displayName = 'TrayHeader';

TrayHeader.propTypes = {
  channel: oneOf(['desktop', 'mobile', 'tablet']),
  dimensions: string,
  subtotal: number
};

TrayHeader.defaultProps = {
  channel: 'desktop',
  dimensions: null,
  subtotal: 0
};
